import { createContext, useState } from 'react';

export const LoaderContext = createContext(null);

export const LoaderProvider = ({ children }) => {
    const [loading, setLoading] = useState(false);

    return <LoaderContext.Provider value={{ loading, setLoading }}>{children}</LoaderContext.Provider>;
};
